// extracted by mini-css-extract-plugin
module.exports = {"container":"totemmodal_container__J4NzA","iframe":"totemmodal_iframe__3QUZW","textContainer":"totemmodal_textContainer__2Kv46","totemText":"totemmodal_totemText__agneR"};